// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__22FR8","footer":"Form_footer__1G7cz"};